var React = require('react');

function InstructorIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.99967 0.333496C3.31967 0.333496 0.333008 3.32016 0.333008 7.00016C0.333008 10.6802 3.31967 13.6668 6.99967 13.6668C10.6797 13.6668 13.6663 10.6802 13.6663 7.00016C13.6663 3.32016 10.6797 0.333496 6.99967 0.333496ZM6.99967 2.3335C8.10634 2.3335 8.99967 3.22683 8.99967 4.3335C8.99967 5.44016 8.10634 6.3335 6.99967 6.3335C5.89301 6.3335 4.99967 5.44016 4.99967 4.3335C4.99967 3.22683 5.89301 2.3335 6.99967 2.3335ZM6.99967 11.8002C5.33301 11.8002 3.85967 10.9468 2.99967 9.6535C3.01967 8.32683 5.66634 7.60016 6.99967 7.60016C8.32634 7.60016 10.9797 8.32683 10.9997 9.6535C10.1397 10.9468 8.66634 11.8002 6.99967 11.8002Z","fill":"currentColor"}));
}

InstructorIcon.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"currentColor"};

module.exports = InstructorIcon;

InstructorIcon.default = InstructorIcon;
